import React, { createContext, useCallback, useEffect, useState } from 'react'
export const ThemeContext = createContext()

const ThemeProvider = ({ location, scrollSmoother, children }) => {
  const [siteTheme, setSiteTheme] = useState('')
  const [showSplash, setShowSplash] = useState(true)
  const [showHero, setShowHero] = useState(true)

  const [resetForm, setFormReset] = useState(false)

  const setTheme = useCallback((name) => {
    setSiteTheme(name)
  }, [])

  const setResetForm = useCallback((v) => {
    setFormReset(v)
  }, [])

  useEffect(() => {
    if (showSplash && location.pathname !== '/') {
      setShowSplash(false)
    }
  }, [location, showSplash, setShowSplash])

  useEffect(() => {
    if (showHero && location.pathname !== '/') {
      setShowHero(false)
    }
  }, [location, showHero, setShowHero])

  return (
    <ThemeContext.Provider
      value={{
        siteTheme,
        setTheme,
        showSplash,
        setShowSplash,
        showHero,
        setShowHero,
        scrollSmoother,
        resetForm,
        setResetForm,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
